<script>
import { mapState } from 'vuex';
import { isEmpty } from 'lodash-es';
import ChannelsDataTable from './ChannelsDataTable';
import JobDataTable from './JobDataTable';
import PricesImportDataTable from './PricesImportDataTable';
import PricesPushDataTable from './PricesPushDataTable';

export default {
  name: 'ProductsList',
  components: { ChannelsDataTable, JobDataTable, PricesImportDataTable, PricesPushDataTable },
  methods: {
    isObjectEmpty(object) {
      return isEmpty(object);
    },
  },
  computed: {
    ...mapState({
      filter: state => state.prices.filter,
    }),
  },
};
</script>

<template>
  <v-flex>
    <prices-import-data-table
      v-if="!isObjectEmpty(this.filter.type) && this.filter.type.type === 'import'"
    />
    <prices-push-data-table
      v-if="!isObjectEmpty(this.filter.type) && this.filter.type.type === 'push'"
    />
    <job-data-table
      v-if="!isObjectEmpty(this.filter.channel) && isObjectEmpty(this.filter.type)"
    />
    <channels-data-table
      v-if="isObjectEmpty(this.filter.channel)"
    />
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/prices/PricesList.vue